export default "__VITE_ASSET__BSfwvEhj__"